/* eslint-disable indent */
import styled from 'styled-components';
import { Avatar } from '@mui/material';
import Badge from '@mui/material/Badge';
import { COLORS } from '../../../theme';

export const StyledAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    font-size: ${({ theme }) => theme.fontSize.h4};
    ${({ theme, size }) =>
      size === 'small' &&
      `
        font-size: ${theme.fontSize.body3};
      `}
    font-weight: 500;
  }
`;

export const StyledBadge = styled(Badge)`
  .MuiBadge-badge {
    background: ${COLORS.white};
    width: ${({ theme }) => theme.spacing.s4};
    cursor: pointer;
  }
`;

export const StyledPhoto = styled.img`
  width: ${({ theme }) => theme.spacing.l2};
  height: ${({ theme }) => theme.spacing.l2};
  border-radius: 50%;
  overflow: hidden;

  ${({ theme, size }) =>
    size === 'small' &&
    `
      width: ${theme.spacing.m2};
      height: ${theme.spacing.m2};
  `}
`;
